import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AppleIcon from "@mui/icons-material/Apple";

import PrivacyPolicyModal from "./privacyPolicy/PrivacyPolicyModal";
import SaasModal from "./privacyPolicy/SaasModel";
import EulaModal from "./privacyPolicy/eulaModal";
import Lottie from "lottie-react";
import dentalHeroAnimation from "../../src/components/animation/Dental Care.json";

import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import styles from "./Login.module.scss";

export default function Login() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showSAASModal, setShowSAASModal] = useState(false);
  const [showEulaModal, setShowEulaModal] = useState(false);

  const [privacyContent, setPrivacyContent] = useState("");
  const [saasContent, setSaasContent] = useState("");
  const [eulaContent, setEulaContent] = useState("");

  const [hasGuestRef, setHasGuestRef] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const guestRef = params.get("guest_purchase_reference");
    setHasGuestRef(Boolean(guestRef));

    if (guestRef) {
      localStorage.setItem("guest_purchase_reference", guestRef);
    }
  }, []);

  const loadDoc = async (id, setter, modalSetter) => {
    try {
      const mockDocs = {
        1: "EULA content goes here.",
        2: "SAAS content goes here.",
        3: "Privacy Policy content goes here.",
      };

      setter(mockDocs[id] || "Document not found.");
    } catch {
      setter("Failed to load document.");
    } finally {
      modalSetter(true);
    }
  };

  const loginDentally = useMutation({
    mutationFn: () =>
      axios.get(`/auth/get_dentally_request_auth_link?capture=default`),
    onSuccess: (res) => window.location.replace(res.data),
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    return;
  };

  const handleGoogleLogin = () => {
    return;
  };

  const handleAppleLogin = () => {
    return;
  };

  return (
    <div className={styles.page}>
      <div className={styles.topBar}>
        <div className={styles.brandWrap}>
          <img src="/logo.png" alt="Medicube" className={styles.logo} />
        </div>

        <button
          className={styles.contactBtn}
          onClick={() => {
            window.location.href = "https://medicube.site/";
          }}
        >
          About Us
        </button>
      </div>

      <main className={styles.main}>
        
        <section className={styles.leftSide}>
          <div className={styles.heroText}>
            <h1>
              Smart Dental Imaging
              & Treatment Platform
            </h1>

            <p>
              Empowering clinics with streamlined imaging, treatment planning,
              and modern patient workflows.
            </p>

            <div className={styles.featureList}>
              <div className={styles.featureItem}>
                <span className={styles.tick}>✓</span>
                <span>AI-assisted dental scan workflows</span>
              </div>

              <div className={styles.featureItem}>
                <span className={styles.tick}>✓</span>
                <span>Faster treatment and consent management</span>
              </div>

              <div className={styles.featureItem}>
                <span className={styles.tick}>✓</span>
                <span>Secure and compliant platform</span>
              </div>
            </div>
          </div>

          <div className={styles.visualWrap}>
            <div className={styles.heroLottieWrap}>
              <Lottie
                animationData={dentalHeroAnimation}
                loop
                autoplay
                className={styles.heroLottie}
              />
            </div>
          </div>
        </section>

        <section className={styles.rightSide}>
          <div className={styles.loginCard}>
            <div className={styles.loginCardHeader}>
              {/* <h2>Sign In</h2> */}
              <h1>Welcome To Medicube</h1>
            </div>

            {/* <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.fieldBlock}>
                <label>Email</label>
                <TextField
                  fullWidth
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  variant="outlined"
                  className={styles.inputField}
                  disabled
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailOutlinedIcon className={styles.inputIcon} />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <div className={styles.fieldBlock}>
                <label>Password</label>
                <TextField
                  fullWidth
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  className={styles.inputField}
                  disabled
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlinedIcon className={styles.inputIcon} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                          disabled
                        >
                          {showPassword ? (
                            <VisibilityOffOutlinedIcon className={styles.inputIcon} />
                          ) : (
                            <VisibilityOutlinedIcon className={styles.inputIcon} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <div className={styles.forgotWrap}>
                <button
                  type="button"
                  className={styles.linkBtn}
                  onClick={() => {}}
                  disabled
                  style={{
                    pointerEvents: "none",
                    opacity: 0.5,
                    cursor: "not-allowed",
                  }}
                >
                  Forgot password?
                </button>
              </div>

              <Button
                type="submit"
                fullWidth
                className={styles.primaryBtn}
                disabled
              >
                Sign In
              </Button>
            </form> */}

            {/* <p className={styles.signupText}>
              New to Medicube.health?{" "}
              <span
                onClick={() => {}}
                style={{
                  pointerEvents: "none",
                  opacity: 0.5,
                  cursor: "not-allowed",
                }}
              >
                Sign Up
              </span>
            </p> */}

            <div className={styles.orWrap}>
              {/* <span className={styles.line} /> */}
              {/* <span className={styles.orText}>Or</span> */}
              {/* <span className={styles.line} /> */}
            </div>

            {hasGuestRef && (
              <div className={styles.alertWrap}>
                <Alert
                  severity="warning"
                  variant="outlined"
                  sx={{
                    borderRadius: 12,
                    borderWidth: 1.5,
                    px: 2,
                    py: 1.25,
                    alignItems: "flex-start",
                    "& .MuiAlertTitle-root": { fontWeight: 800, mb: 0.5 },
                    "& .MuiAlert-icon": { mt: "2px" },
                  }}
                >
                  <AlertTitle>Important notice</AlertTitle>
                  When you connect to Dentally via Medicube for the first time,
                  Dentally may show a standard warning related to third-party
                  access and data security.
                  <br />
                  <br />
                  Medicube only requests the minimum information required for
                  the workflow. Read our{" "}
                  <span
                    className={styles.inlineLink}
                    onClick={() =>
                      loadDoc(3, setPrivacyContent, setShowPrivacyModal)
                    }
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        loadDoc(3, setPrivacyContent, setShowPrivacyModal);
                      }
                    }}
                  >
                    Privacy Policy
                  </span>
                  .
                </Alert>
              </div>
            )}

            <Button
          className={styles.DentlyBtnLight}
          onClick={() => loginDentally.mutate()}
          disabled={loginDentally.isPending}
        >
          <span className={styles.dentallyText}>
            {loginDentally.isPending ? "Redirecting..." : "Login via"}
          </span>
          <img src="/dentally-Photoroom.png" alt="Dentally" />
        </Button>

            {/* <button
              type="button"
              className={styles.socialBtnLight}
              onClick={handleGoogleLogin}
              disabled
              style={{
                pointerEvents: "none",
                opacity: 0.5,
                cursor: "not-allowed",
              }}
            >
              <img
                src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                alt="Google"
              />
              <span>
                Sign in with <strong>Google</strong>
              </span>
            </button> */}

            {/* <button
              type="button"
              className={styles.socialBtnDark}
              onClick={handleAppleLogin}
              disabled
              style={{
                pointerEvents: "none",
                opacity: 0.5,
                cursor: "not-allowed",
              }}
            >
              <AppleIcon />
              <span>
                Sign in with <strong>Apple</strong>
              </span>
            </button> */}

            <div className={styles.cardFooter}>
              <span onClick={() => loadDoc(2, setSaasContent, setShowSAASModal)}>
                Terms
              </span>
              <span>·</span>
              <span
                onClick={() =>
                  loadDoc(3, setPrivacyContent, setShowPrivacyModal)
                }
              >
                Privacy
              </span>
              <span>·</span>
              <span>2024 · All rights reserved</span>
            </div>
          </div>
        </section>
      </main>

      <footer className={styles.bottomFooter}>
        © Medicube.health 2024. All rights reserved.
      </footer>

      <PrivacyPolicyModal
        open={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
        content={privacyContent}
      />
      <SaasModal
        open={showSAASModal}
        onClose={() => setShowSAASModal(false)}
        content={saasContent}
      />
      <EulaModal
        open={showEulaModal}
        onClose={() => setShowEulaModal(false)}
        content={eulaContent}
      />
    </div>
  );
}